export const modalSx = {
    position: 'absolute',
    backgroundColor: '#fff',
    border: '1px solid black',
    borderRadius: '10px',
    padding: '10px',
    display: 'flex',
    flexDirection: 'column',
    gap: '5px'
}

export const invisibleDiv = {
    position: 'fixed',
    top: 0,
    left: 0,
    width: '100%',
    height: '100%'
}

export const optionSx = {
    cursor: 'pointer'
}

export const disabledOptionSx = {
    opacity: '0.5'
}
